import moment from "moment";

const PurchaseBasicDetails = ({ item }) => {
  const vendorData = [
    {
      label: "Requested Date",
      value: moment(item?.created_at).format("DD MMM YYYY"),
    },
    {
      label: "Priority",
      value: (
        <div className="flex flex-row gap-1 items-center">
          {item?.priority === 1 ? (
            <>
              <span className="bg-warning-900 w-2 h-2 rounded-full"></span>
              <span>Low</span>
            </>
          ) : (
            <>
              <span className="bg-error-900 w-2 h-2 rounded-full"></span>
              <span>High</span>
            </>
          )}
        </div>
      ),
    },
    {
      label: "Expected Date",
      value: moment(item?.expected_date).format("DD MMM YYYY"),
    },
    { label: "Created By", value: item?.created_by },
  ];

  return (
    <div className="grid grid-cols-2 gap-4">
      {vendorData.map((item, index) => {
        return (
          <div key={index} className="flex flex-col font-medium">
            <span className="text-gray-600">{item.label}</span>
            <span className="text-theme font-bold">{item.value}</span>
          </div>
        );
      })}
    </div>
  );
};
export default PurchaseBasicDetails;
